import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  icon?: ReactNode;
  busy?: boolean;
  block?: boolean;
}

export function Button({ variant = 'primary', icon, busy, block, children, className = '', disabled, ...props }: ButtonProps) {
  return (
    <button
      className={`button button--${variant}${block ? ' button--block' : ''} ${className}`}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      {...props}
    >
      {busy ? <span className="spinner" aria-hidden="true" /> : icon}
      <span>{children}</span>
    </button>
  );
}
